import {
  Component,
  FieldComponent,
  FieldSet,
  Resource,
  Schema,
} from 'simpli-web-sdk'
import {MotoristaJornada} from '@/model/resource/MotoristaJornada'

export class InputMotoristaJornadaSchema extends Schema {
  readonly name = 'InputMotoristaJornada'
  readonly fieldSet: FieldSet<MotoristaJornada> = {
    horaInicio: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'time',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    horaFim: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'time',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    rangeCepInicial: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'zipcode',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    rangeCepFinal: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'zipcode',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    segunda: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    terca: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    quarta: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    quinta: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    sexta: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    sabado: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    domingo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
